import { FormFieldDefinition } from '../../../../../../generic/universal-table/types/form.types'
import { PackageUiRow } from '../types/packageTable.types'

export const packageTableFormFields: FormFieldDefinition<PackageUiRow>[] = [
  {
    name: 'Pack_Name',
    label: 'שם אריזה',
    inputType: 'text',
    required: true,
    placeholder: 'הזן שם אריזה',
    validationRules: {
      required: true,
      minLength: 1,
      maxLength: 100,
    },
  },
  {
    // getOptions is injected in PackageTableModule.tsx
    name: 'SupplierID',
    label: 'ספק',
    inputType: 'searchable-select',
    required: false,
  },
  {
    // getOptions is injected in PackageTableModule.tsx
    name: 'Pack_Type',
    label: 'סוג אריזה',
    inputType: 'searchable-select',
    required: false,
  },
  {
    name: 'Catalog_Number',
    label: 'מספר קטלוגי',
    inputType: 'text',
    required: false,
    placeholder: 'מספר קטלוגי',
    validationRules: {
      maxLength: 50,
    },
  },
  {
    name: 'Pack_Size',
    label: 'גודל',
    inputType: 'text',
    required: false,
    placeholder: 'גודל אריזה',
    validationRules: {
      maxLength: 50,
    },
  },
  {
    name: 'Eng_Desc',
    label: 'תיאור אנגלית',
    inputType: 'text',
    required: false,
    placeholder: 'English description',
    validationRules: {
      maxLength: 100,
    },
  },
  {
    name: 'Main_PackID',
    label: 'אריזה ראשית',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Pack_Price',
    label: 'מחיר',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Export_Weight',
    label: 'משקל יצוא',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Qty4Pallets',
    label: 'כמות למשטח',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Tare_Weight',
    label: 'משקל טרה',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Volume',
    label: 'נפח',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Cooling_Fee',
    label: 'דמי קירור',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Credit_Fee',
    label: 'דמי אשראי',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Usage_Fee',
    label: 'דמי שימוש',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Active',
    label: 'פעיל',
    inputType: 'boolean-select',
    required: false,
    defaultValue: true,
  },
  {
    name: 'DepositWithVAT',
    label: 'פיקדון כולל מעמ',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Download_from_Warehouse',
    label: 'פריקה ממחסן',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Inventory',
    label: 'מלאי',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Providence',
    label: 'השגחה',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Tranzit_Fee',
    label: 'דמי מעבר',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
]
